import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11795550&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11795550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11795550')) {
      api.createRecord('11795550', component.options)
    } else {
      api.reload('11795550', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=11795550&scoped=true&", function () {
      api.rerender('11795550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/systemCreator/systemConfig/resaleTaxConfig1/index.vue"
export default component.exports